import * as css from 'css/exports.module.scss';
import './Index.scss';
import { CommentSection } from './comments';
import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { InitiativeDescription } from './Description';
import { InitiativeSidebar } from './sidebar';
import { InitiativeSummary } from './summary';
import { InitiativeTitleBar } from './TitleBar';
import { ScopeSection } from './scopes';
import { TaskSection } from './tasks';
import { useNavigate } from 'react-router-dom';
import { Col, Row } from 'antd';
import React, { useEffect } from 'react';
import { ScrollShadow, SonarCard } from '@ui/general';
import { useCurrentInitiative, usePeriscopeCount, useSonarSelector } from '@hooks';
export const InitiativeCard = ({ initiativeId }) => {
    var _a, _b;
    const navigate = useNavigate();
    const isErrored = useSonarSelector(useCurrentInitiative.selectors.isErrored);
    const isPeriscopeOpen = Boolean(usePeriscopeCount());
    const initiative = useCurrentInitiative();
    const isLoading = useSonarSelector(useCurrentInitiative.selectors.isRequested) && !initiative;
    useEffect(() => {
        if (isErrored) {
            navigate(FULL_ROUTES.INITIATIVES, { replace: true });
        }
    }, [isErrored, navigate]);
    return (React.createElement(ScrollShadow, { scroller: '.ant-card-body', shadow: '.ant-card-head' },
        React.createElement(SonarCard, { loading: isLoading, title: React.createElement(InitiativeTitleBar, { initiativeId: initiativeId, title: initiative === null || initiative === void 0 ? void 0 : initiative.title }) },
            React.createElement(Row, { gutter: Number(css.size32), justify: 'space-between', wrap: true },
                React.createElement(Col, { span: isPeriscopeOpen ? 24 : 20 },
                    React.createElement(InitiativeDescription, { description: initiative === null || initiative === void 0 ? void 0 : initiative.description, initiativeId: initiativeId }),
                    React.createElement(InitiativeSummary, { initiativeId: initiativeId })),
                React.createElement(Col, { span: isPeriscopeOpen ? 0 : 4 },
                    React.createElement(InitiativeSidebar, { assignedTo: (_a = initiative === null || initiative === void 0 ? void 0 : initiative.assignedTo) !== null && _a !== void 0 ? _a : 0, createdBy: (_b = initiative === null || initiative === void 0 ? void 0 : initiative.createdBy) !== null && _b !== void 0 ? _b : 0, initiativeId: initiativeId, status: initiative === null || initiative === void 0 ? void 0 : initiative.initiativeStatusId }))),
            React.createElement(ScopeSection, { initiativeId: initiativeId }),
            React.createElement(TaskSection, { initiativeId: initiativeId }),
            React.createElement(CommentSection, { initiativeId: initiativeId }))));
};
